import React from "react";
import { connect } from "react-redux";

import { IonItem, IonIcon, IonLabel } from "@ionic/react";
import { menuController } from "@ionic/core/components";

import {
  calendarOutline,
  home,
  peopleOutline,
  helpOutline,
  statsChartOutline,
  helpCircleOutline,
  hammerOutline,
} from "ionicons/icons";

import { loadQuiz } from "services/quiz";
// import { WSemit } from "services/socket";

interface Props {
  quizData: any;
  loadQuiz: Function;
}

const FrontendMenu: React.FC<Props> = ({ quizData, loadQuiz }) => {
  const closeMenu = async () => {
    await menuController.toggle("main");
  };

  const onStartQuiz = () => {
    closeMenu();
    loadQuiz();
  };

  return (
    <>
      <IonItem
        color="light"
        routerLink="/dashboard"
        onClick={closeMenu}
        lines="none"
      >
        <IonIcon slot="start" icon={home}></IonIcon>
        <IonLabel>Dashboard</IonLabel>
      </IonItem>
      {/* <IonItemDivider>
        <IonLabel>Menu</IonLabel>
      </IonItemDivider> */}
      {quizData.quizId !== 0 && (
        <>
          <IonItem
            color="light"
            routerLink={`/quiz`}
            onClick={onStartQuiz}
            lines="none"
            menu-close
          >
            <IonIcon slot="start" icon={calendarOutline}></IonIcon>
            <IonLabel>Quiz</IonLabel>
          </IonItem>
          <IonItem
            color="light"
            routerLink={`/questions`}
            onClick={closeMenu}
            lines="none"
          >
            <IonIcon slot="start" icon={helpCircleOutline}></IonIcon>
            <IonLabel>Review Questions</IonLabel>
          </IonItem>
          <IonItem
            color="light"
            routerLink={`/teams`}
            onClick={closeMenu}
            lines="none"
          >
            <IonIcon slot="start" icon={peopleOutline}></IonIcon>
            <IonLabel>Teams</IonLabel>
          </IonItem>
          <IonItem
            color="light"
            routerLink={`/scoring`}
            onClick={closeMenu}
            lines="none"
          >
            <IonIcon slot="start" icon={statsChartOutline}></IonIcon>
            <IonLabel>Scoring</IonLabel>
          </IonItem>
        </>
      )}
      <IonItem
        color="light"
        routerLink={`/help`}
        onClick={closeMenu}
        lines="none"
      >
        <IonIcon slot="start" icon={helpOutline}></IonIcon>
        <IonLabel>Help</IonLabel>
      </IonItem>
      <IonItem
        color="light"
        routerLink={`/tools`}
        onClick={closeMenu}
        lines="none"
      >
        <IonIcon slot="start" icon={hammerOutline}></IonIcon>
        <IonLabel>Tools</IonLabel>
      </IonItem>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  quizData: state.quiz,
});

export default connect(mapStateToProps, { loadQuiz })(FrontendMenu);
